import { jsxs, jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import classNames from 'classnames';
import { Button } from '../../Button/Button.es.js';
import { Icon } from '../../Icon/Icon.es.js';

const DatePickerHeader = ({ monthsShown = 1, monthDate, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled, locale, customHeaderCount })=>{
    const localeWithFallback = useMemo(()=>({
            decrease: 'Decrease month',
            increase: 'Increase month',
            ...locale
        }), [
        locale
    ]);
    if (monthsShown > 1) {
        return jsxs("div", {
            className: classNames('date-picker-header-wide', {
                'left-header': customHeaderCount === 0
            }),
            children: [
                jsx(Button, {
                    className: classNames('icon-button-wide', 'rotate', {
                        'prev-month-button-disabled': prevMonthButtonDisabled,
                        'prev-month-button-hidden': customHeaderCount === 1
                    }),
                    disabled: prevMonthButtonDisabled,
                    label: localeWithFallback.decrease,
                    onClick: decreaseMonth,
                    variant: "secondary",
                    iconOnly: true,
                    children: jsx(Icon, {
                        name: "ChevronRightSolid",
                        size: 24
                    })
                }),
                jsxs("div", {
                    className: "month-year",
                    children: [
                        jsx("span", {
                            className: "month",
                            children: monthDate.toLocaleString(locale.code, {
                                month: 'long'
                            })
                        }),
                        jsx("span", {
                            children: monthDate.toLocaleString(locale.code, {
                                year: 'numeric'
                            })
                        })
                    ]
                }),
                jsx(Button, {
                    className: classNames('icon-button-wide', {
                        'next-month-button-disabled': nextMonthButtonDisabled,
                        'next-month-button-hidden': customHeaderCount === 0
                    }),
                    disabled: nextMonthButtonDisabled,
                    label: localeWithFallback.increase,
                    onClick: increaseMonth,
                    variant: "secondary",
                    iconOnly: true,
                    children: jsx(Icon, {
                        name: "ChevronRightSolid",
                        size: 24
                    })
                })
            ]
        });
    }
    return jsxs("div", {
        className: "date-picker-header",
        children: [
            jsxs("div", {
                className: "month-year",
                children: [
                    jsx("span", {
                        className: "month",
                        children: monthDate.toLocaleString(locale.code, {
                            month: 'long'
                        })
                    }),
                    jsx("span", {
                        children: monthDate.toLocaleString(locale.code, {
                            year: 'numeric'
                        })
                    })
                ]
            }),
            jsxs("div", {
                className: "navigator",
                children: [
                    jsx(Button, {
                        className: classNames('icon-button', {
                            'prev-month-button-disabled': prevMonthButtonDisabled
                        }),
                        disabled: prevMonthButtonDisabled,
                        label: localeWithFallback.decrease,
                        onClick: decreaseMonth,
                        variant: "secondary",
                        iconOnly: true,
                        children: jsx(Icon, {
                            name: "ChevronRightSolid",
                            size: 24
                        })
                    }),
                    jsx(Button, {
                        className: classNames('icon-button', {
                            'next-month-button-disabled': nextMonthButtonDisabled
                        }),
                        disabled: nextMonthButtonDisabled,
                        label: localeWithFallback.increase,
                        onClick: increaseMonth,
                        variant: "secondary",
                        iconOnly: true,
                        children: jsx(Icon, {
                            name: "ChevronRightSolid",
                            size: 24
                        })
                    })
                ]
            })
        ]
    });
};

export { DatePickerHeader };
//# sourceMappingURL=DatePicker.Header.es.js.map
